<div class="grid-content">
  <app-comparative-grid
    [isVisible]="isActive"
    [metaReady]="metaReady"
    [dataReady]="!isCompsDataInProgress"
    [isTimeSeries]="false"
    [fuzzySwitch]="highlightBestMatches"
    [dataSource$]="compsGridData$.asObservable()"
    [hasFormulaBar]="true"
    [tableClassName]="'comparative-comp-table-container'"
    [allowTickerDeletion]="false"
    [showCompanyCount]="showCompanyCount"
    [sortByColumnId]="sortByColumnId"
    tableClassName="comparative-analysis-grid-container"
    (onShowChart)="showChartPopup($event)"
    (updateTickerOrder)="updateTickerOrder($event)"
  >
  </app-comparative-grid>
  <div *ngIf="isCompsDataInProgress" class="grid-overlay-loader">
    <img
      class="grid-overlay-loader-img"
      alt="Loading"
      [src]="assets + '/spinner-blue.gif'"
      width="64"
      height="64"
    />
  </div>
</div>
